import { render, staticRenderFns } from "./d2-container-ghost.vue?vue&type=template&id=64e90ce0&"
import script from "./d2-container-ghost.vue?vue&type=script&lang=js&"
export * from "./d2-container-ghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e90ce0')) {
      api.createRecord('64e90ce0', component.options)
    } else {
      api.reload('64e90ce0', component.options)
    }
    module.hot.accept("./d2-container-ghost.vue?vue&type=template&id=64e90ce0&", function () {
      api.rerender('64e90ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-container/components/d2-container-ghost.vue"
export default component.exports